import { FormFieldRow } from '@/components/forms/BookTradeForm/FormFieldRow'
import { BaseStructuredFormFields } from '@/pages/instruments/new-instrument/fields/base-structured.fields'
import { OptionalStructuredFields } from '@/pages/instruments/new-instrument/fields/structured.optional.fields'
import { ContractTypeField } from '@/pages/instruments/new-instrument/form-fields/ContractTypeFormField'
import { CouponRateAnnualFormField } from '@/pages/instruments/new-instrument/form-fields/CouponRateAnnualFormField'
import { KnockDownInputLevelFormField } from '@/pages/instruments/new-instrument/form-fields/KnockDownInputLevelFormField'
import { PayoffBarrierLevelFormField } from '@/pages/instruments/new-instrument/form-fields/PayoffBarrierLevelFormField'
import { SideField } from '@/pages/instruments/new-instrument/form-fields/SideFormField'

export interface DigitalFormFieldsProps {}

export const DigitalFormFields: React.FC<DigitalFormFieldsProps> = ({}) => {
  return (
    <div className="grid gap-6 @2xl:grid-cols-2 @2xl:gap-10">
      <BaseStructuredFormFields />
      <div className={'@container flex flex-col gap-6'}>
        <FormFieldRow>
          <ContractTypeField />
          <SideField />
          <CouponRateAnnualFormField />
          <PayoffBarrierLevelFormField />
        </FormFieldRow>
        <FormFieldRow>
          <KnockDownInputLevelFormField />
        </FormFieldRow>
        <OptionalStructuredFields />
      </div>
    </div>
  )
}
